import { GET_FIN_YEARS, FIN_YEAR_REQUEST, FIN_YEAR_FAILURE, CREATE_FIN_YEAR, UPDATE_FIN_YEAR, DELETE_FIN_YEAR } from '../types';

const initialState = {
  finyears: [],
  loading: false,
  error: null
};

const finyearReducer = (state = initialState, action) => {
  switch (action.type) {
    case FIN_YEAR_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_FIN_YEARS:
      return {
        ...state,
        finyears: action.payload,
        loading: false,
        error: null
      };
    case CREATE_FIN_YEAR:
      return {
        ...state,
        loading: false,
        error: null,
        finyears: [action.payload, ...state.finyears],
      }
    case UPDATE_FIN_YEAR: {
      const finyearsData = state.finyears.slice(0);
      const uIndex = finyearsData.findIndex((data) => data.id === action.payload.id);
      finyearsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        finyears: [ ...finyearsData ],
        loading: false,
        error: null
      };
    }
    case DELETE_FIN_YEAR: {
      const finyears = state.finyears?.slice(0);
      const index = finyears.findIndex((data) => data.id === action.id);
      if (index > -1) {
        finyears.splice(index, 1);
      }
      return {
        ...state,
        finyears: [...finyears],
        loading: false,
        error: null
      }
    }
    case FIN_YEAR_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default finyearReducer;
